import {IStateService} from "angular-ui-router";

class MainViewController {
    hideSidebar;
    constructor(private $state: IStateService){
        this.hideSidebar = false;
    }
}

class MainViewOptions implements ng.IComponentOptions {
    controllerAs =  'c';
    public controller:string = "rkcMainController";
    public template: any = require('./main.html');
}

rkcApp.controller("rkcMainController", ['$state',function($state){
    return new MainViewController($state);
}])
    .component("rkcMain", new MainViewOptions());


/** WEBPACK FOOTER **
 ** ./src/app/components/main/main.ts
 **/